import IndexDBWrapper from 'indexdbwrapper'

class Database {
    db
    constructor() {
        if (this.db == null) {
            const dbName = 'LeverageXDb', version = 2
            const db = new IndexDBWrapper(dbName, version, {
                onupgradeneeded(event) {
                    const innerDb = event.target.result

                    // 1. 仓位计算器表
                    const tbCalculation = "Calculation"
                    if (!innerDb.objectStoreNames.contains(tbCalculation)) {
                        innerDb.createObjectStore(tbCalculation, {
                            keyPath: "Id"
                        })
                        // Id TEXT PRIMARY KEY,  
                        // Lever INTEGER NOT NULL,
                        // Amount REAL NOT NULL,
                        // TransAmount REAL NOT NULL,
                        // StopLoss REAL,
                        // TakeProfit REAL,
                        // StopLossAmount REAL,
                        // TakeProfitAmount REAL
                    }

                    // 2. 仓位开仓工具表
                    const tbEntry = "Entry"
                    if (!innerDb.objectStoreNames.contains(tbEntry)) {
                        let objectStore = innerDb.createObjectStore(tbEntry, {
                            keyPath: "Id"
                        })
                        objectStore.createIndex("Symbol", "Symbol", { unique: false })
                        // Id TEXT PRIMARY KEY,  
                        // Symbol TEXT NOT NULL,
                        // Lever INTEGER NOT NULL,
                        // Amount REAL NOT NULL,
                        // TransAmount REAL NOT NULL,
                        // StopLoss REAL,
                        // TakeProfit REAL,
                        // StopLossAmount REAL,
                        // TakeProfitAmount REAL,
                        // Status INTEGER NOT NULL DEFAULT 0
                    }

                    // 3. 交易对收藏表
                    const tbUCollect = "UCollect"
                    if (!innerDb.objectStoreNames.contains(tbUCollect)) {
                        let objectStore = innerDb.createObjectStore(tbUCollect, {
                            keyPath: "Id"
                        })
                        objectStore.createIndex("Symbol", "Symbol", { unique: true })
                        objectStore.createIndex("Sort", "Sort", { unique: false })
                    }

                    // 4. API设置表
                    const tbApi = "Api"
                    if (!innerDb.objectStoreNames.contains(tbApi)) {
                        let objectStore = innerDb.createObjectStore(tbApi, {
                            keyPath: "Id"
                        })
                        objectStore.createIndex("ApiType", "ApiType", { unique: false })
                        // Id TEXT PRIMARY KEY,  
                        // ApiKey TEXT NOT NULL,
                        // Secret TEXT NOT NULL,
                        // Password,
                        // ApiType TEXT NOT NULL
                    }

                    // 5. 盈亏比设置表
                    const tbRisk = "Risk"
                    if (!innerDb.objectStoreNames.contains(tbRisk)) {
                        innerDb.createObjectStore(tbRisk, {
                            keyPath: "Id"
                        })
                        // Id TEXT PRIMARY KEY,  
                        // RiskValue REAL NOT NULL
                    }

                    // 6. 持仓模式设置表
                    const tbWorkingType = "WorkingType"
                    if (!innerDb.objectStoreNames.contains(tbWorkingType)) {
                        let objectStore = innerDb.createObjectStore(tbWorkingType, {
                            keyPath: "Id"
                        })
                        objectStore.createIndex("Platform", "Platform", { unique: false })
                        objectStore.createIndex("Name", "Name", { unique: false })
                        objectStore.createIndex("Type", "Type", { unique: false })
                    }
                }
            })
            this.db = db
        }
    }

    async deleteDatabase() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.deleteDatabase('LeverageXDb');
            request.onsuccess = () => {
                console.log('数据库删除成功');
                this.db = null;
                resolve(true);
            };
            request.onerror = (event) => {
                console.error('删除数据库失败:', event);
                reject(event.target.error);
            };
        });
    }

    // 插入或更新数据
    insert(table, data, type) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], type || "readwrite", (txn, value) => {
                let objectStore = txn.objectStore(table)
                const request = objectStore.put(data)
                request.onsuccess = (event) => {
                    resolve(event.target.result)
                }
                request.onerror = (event) => {
                    reject(event.target.error)
                }
            })
        })
    }

    // 批量插入
    insertBatch(table, dataArray) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], "readwrite", (txn, value) => {
                let objectStore = txn.objectStore(table)
                let promises = dataArray.map(data => {
                    return new Promise((res, rej) => {
                        const request = objectStore.put(data)
                        request.onsuccess = () => res()
                        request.onerror = () => rej(request.error)
                    })
                })
                Promise.all(promises).then(resolve).catch(reject)
            })
        })
    }

    // 查询单条数据
    selectOne(table, id) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], "readonly", (txn, value) => {
                let objectStore = txn.objectStore(table)
                const request = objectStore.get(id)
                request.onsuccess = (event) => {
                    resolve(event.target.result)
                }
                request.onerror = (event) => {
                    reject(event.target.error)
                }
            })
        })
    }

    // 查询所有数据
    selectAll(table) {
        return this.db.getAll(table)
    }

    // 条件查询
    async select(table, condition = {}) {
        // 如果没有查询条件，返回所有数据
        if (Object.keys(condition).length === 0) {
            return await this.db.getAll(table);
        }

        // 根据索引精确查询
        if (condition.index && condition.value !== undefined) {
            try {
                // 方法1：使用 getAllMatching
                const result = await this.db.getAllMatching(table, {
                    index: condition.index,
                    query: condition.value  // 注意：有些版本用 query，不是 equals
                });
                return result;
            } catch (error) {
                console.error('getAllMatching 失败，尝试其他方法:', error);

                // 方法2：使用原生 API
                return new Promise((resolve, reject) => {
                    const transaction = this.db.transaction([table], 'readonly');
                    const objectStore = transaction.objectStore(table);
                    const index = objectStore.index(condition.index);
                    const request = index.getAll(condition.value);

                    request.onsuccess = () => resolve(request.result);
                    request.onerror = () => reject(request.error);
                });
            }
        }

        // 其他查询方式
        const allData = await this.db.getAll(table);
        return allData.filter(item => {
            return Object.entries(condition).every(([key, value]) => {
                return item[key] === value;
            });
        });
    }

    // 根据索引查询
    selectByIndex(table, indexName, value) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], "readonly", (txn, value) => {
                let objectStore = txn.objectStore(table)
                let index = objectStore.index(indexName)
                const request = index.getAll(value)
                request.onsuccess = (event) => {
                    resolve(event.target.result)
                }
                request.onerror = (event) => {
                    reject(event.target.error)
                }
            })
        })
    }

    // 删除数据
    delete(table, id) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], "readwrite", (txn, value) => {
                let objectStore = txn.objectStore(table)
                const request = objectStore.delete(id)
                request.onsuccess = () => resolve(true)
                request.onerror = (event) => reject(event.target.error)
            })
        })
    }

    // 在 Database 类中添加
    async deleteWhere(table, condition) {
        // condition 格式: { field: 'Symbol', operator: 'eq', value: 'BTCUSDT' }
        // 或简写: { Symbol: 'BTCUSDT' }

        let records;

        // 如果 condition 包含 index 信息，使用索引查询
        if (condition.index && condition.value) {
            records = await this.selectByIndex(table, condition.index, condition.value);
        }
        // 如果是简单对象格式 { Symbol: 'BTCUSDT' }
        else if (typeof condition === 'object' && !condition.index) {
            // 获取所有数据并过滤
            const allData = await this.selectAll(table);
            records = allData.filter(item => {
                return Object.entries(condition).every(([key, value]) => {
                    return item[key] === value;
                });
            });
        }
        else {
            throw new Error('不支持的查询条件格式');
        }

        if (!records || records.length === 0) {
            return { deleted: false, count: 0 };
        }

        const ids = records.map(record => record.Id);
        await this.deleteBatch(table, ids);

        return { deleted: true, count: ids.length };
    }

    // 批量删除
    deleteBatch(table, ids) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], "readwrite", (txn, value) => {
                let objectStore = txn.objectStore(table)
                let promises = ids.map(id => {
                    return new Promise((res, rej) => {
                        const request = objectStore.delete(id)
                        request.onsuccess = () => res()
                        request.onerror = () => rej(request.error)
                    })
                })
                Promise.all(promises).then(resolve).catch(reject)
            })
        })
    }

    // 清空表
    clear(table) {
        return new Promise((resolve, reject) => {
            this.db.transaction([table], "readwrite", (txn, value) => {
                let objectStore = txn.objectStore(table)
                const request = objectStore.clear()
                request.onsuccess = () => resolve(true)
                request.onerror = (event) => reject(event.target.error)
            })
        })
    }

    // 更新数据
    update(table, data) {
        return this.insert(table, data)
    }
}

const database = new Database()
export default database